import { NormalizeOAS, OASRequestParams, OASResponse } from 'fets';
import type assetLibraryOpenApi from '../asset-library-open-api';
import { AssetLibraryFetsApiClient } from '../asset-library-fets-client';
import { assertNever } from '../utils';
import { Guid } from '../../api/public/utils/Guid';
import { Folder } from './createAssetFolder';

const PATH = '/api/v2/asset-directory/company/{companyId}/rename/{directoryId}';

type Params = {
  companyId: Guid;
  directoryId: Guid;
  name: string;
};

type Result = Folder;

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<Result>;

export const createRenameAssetFolder = (apiClient: AssetLibraryFetsApiClient): ApiFunction => {
  const renameAssetFolder = async (params: Params, signal?: AbortSignal): Promise<Result> => {
    const response = await apiClient[PATH].put({
      ...convertToRequest(params),
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return renameAssetFolder;
};

type Request = OASRequestParams<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'put'>;
type Response = OASResponse<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'put'>;

const convertToRequest = (params: Params): Request => ({
  params: { companyId: params.companyId, directoryId: params.directoryId },
  json: { name: params.name },
});

const convertResponse = async (response: Response): Promise<Result> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }

  const data = await response.json();
  const result: Result = {
    id: data.id,
    name: data.name,
    parentId: data.parentId ?? null,
  };
  return result;
};
